import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

const escapeHtml = (value) => (
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
);

const htmlToPlainText = (html) => {
  if (!html) return '';

  const normalizedHtml = DOMPurify.sanitize(html)
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6])>/gi, '\n')
    .replace(/<li[^>]*>/gi, '- ');

  if (typeof document === 'undefined') {
    return normalizedHtml
      .replace(/<[^>]+>/g, '')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  const container = document.createElement('div');
  container.innerHTML = normalizedHtml;

  return (container.textContent || container.innerText || '')
    .replace(/\r\n?/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

const plainTextToHtml = (plainText) => {
  const normalizedText = plainText.replace(/\r\n?/g, '\n');

  if (!normalizedText.trim()) return '';

  return normalizedText
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br>')}</p>`)
    .join('');
};

const ReminderRichTextEditor = ({
  value,
  onChange,
  placeholder = 'Write reminder content...',
  readOnly = false
}) => {
  const [draftValue, setDraftValue] = useState(() => htmlToPlainText(value || ''));

  useEffect(() => {
    setDraftValue(htmlToPlainText(value || ''));
  }, [value]);

  if (readOnly) {
    return (
      <div className="un-path-reminders__ckeditor-view">
        <div
          className="un-path-reminders__ckeditor-view-body"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value || '') }}
        />
      </div>
    );
  }

  return (
    <textarea
      className="un-path-reminders__fallback-editor"
      value={draftValue}
      placeholder={placeholder}
      onChange={(event) => {
        const nextValue = event.target.value;
        setDraftValue(nextValue);
        onChange?.(plainTextToHtml(nextValue));
      }}
      rows={12}
    />
  );
};

export default ReminderRichTextEditor;
